import { useEffect } from 'react';
import { useTheme } from '@mui/material';
import { Capacitor, SystemBarsStyle } from '@capacitor/core';
import { useColorScheme } from 'hooks/useColorScheme';
import { setStatusBarStyle } from 'shared/mobile';

/**
 * Sets the Android status bar color and style to match the given background color.
 * Automatically picks light/dark status bar style based on the current color scheme.
 */
export const useSetStatusBarStyle = (bgColor: string): void => {
  const { isDarkMode } = useColorScheme();
  const theme = useTheme();

  useEffect(() => {
    if (Capacitor.getPlatform() !== 'android') return undefined;
    // Using a timeout to work around a race condition that happens in Android 16, see ENG-4932
    const timeoutId = window.setTimeout(() => {
      setStatusBarStyle({
        bgColor,
        style: isDarkMode ? SystemBarsStyle.Dark : SystemBarsStyle.Light,
      });
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [bgColor, isDarkMode, theme]);
};
